import { STATUS_GREEN, STATUS_RED } from "@/shared/lib/statusColors";
import { cn } from "@/shared/lib/utils";
import { type VaultThresholds, vaultTier } from "../setup.bosses";

const TIER_STYLES = {
  // Status colors are intentionally fixed: the four Vault slots must stay distinct in every theme.
  // Tiers 0 (under) and 3 (full) share the app-wide status washes; the middle tiers are local.
  0: STATUS_RED,
  1: "bg-[color-mix(in_oklab,oklch(0.72_0.14_75)_18%,var(--background))] text-[oklch(0.62_0.13_75)]",
  2: "bg-[color-mix(in_oklab,oklch(0.62_0.15_250)_17%,var(--background))] text-[oklch(0.58_0.15_250)]",
  3: STATUS_GREEN,
} as const;

export function VaultCell({
  count,
  thresholds,
  className,
}: {
  count: number;
  thresholds: VaultThresholds;
  className?: string;
}) {
  return (
    <td
      className={cn(
        "h-10 min-w-16 p-0 text-center text-sm font-semibold tabular-nums",
        TIER_STYLES[vaultTier(count, thresholds)],
        className,
      )}
    >
      {count}
    </td>
  );
}
